<template>
  <div class="paper-exam">
    <div class="title">基本信息</div>
    <Form ref="exercise" :model="exercise" :rules="ruleExercise" :label-width="120">
      <FormItem label="练习名称" prop="name">
        <Input
          v-model="exercise.name"
          :maxlength="30"
          placeholder="请输入练习名称，不能超过30个字"
          style="width: 400px;"
          clearable
        ></Input>
        <span style="padding-left: 10px;">{{exercise.name.length}}/30</span>
      </FormItem>
      <FormItem label="练习分类" prop="classify_ids">
        <Cascader
          :data="catagoris"
          v-model="exercise.classify_ids"
          style="width:200px;"
          change-on-select
        ></Cascader>
      </FormItem>
      <FormItem label="封面图片" prop="indexpic">
        <UploadFile
          url="/api/public/img"
          :format="['jpg','jpeg','gif','png']"
          @onSuccess="onUploadSuccess"
        ></UploadFile>
        <div class="tip">*尺寸为 220 * 220 , 请上传jpg, png格式的图片, 建议图片大小不超过2MB。</div>
        <div v-if="exercise.indexpic">
          <img :src="exercise.indexpic" style="width:110px;height:110px;" />
        </div>
      </FormItem>
      <FormItem label="详情页图片" prop="mainpic">
        <UploadFile
          url="/api/public/img"
          :format="['jpg','jpeg','gif','png']"
          @onSuccess="onUploadMainSuccess"
        ></UploadFile>
        <div class="tip">*尺寸为 375 * 209 , 请上传jpg, png格式的图片, 建议图片大小不超过2MB。</div>
        <div v-if="exercise.mainpic">
          <img :src="exercise.mainpic" style="width:375px;height:209px;" />
        </div>
      </FormItem>
      <FormItem label="是否关联课程" prop="is_related_course">
        <RadioGroup v-model="exercise.is_related_course">
          <Radio :label="1" :value="1">是</Radio>
          <Radio :label="0" :value="0">否</Radio>
        </RadioGroup>
        <div v-if="exercise.is_related_course > 0">
          <Tag v-if="exercise.related_course_id>0"
            type="border"
            closable @on-close="relatedCourseDelete()"
          >{{exercise.related_course.name}}</Tag>
          <Button type="default" @click="showSelectCourse=true">
            <i class="ivu-icon ivu-icon-ios-add"></i>选择课程
          </Button>
        </div>
      </FormItem>
      <div class="title">上架信息</div>
      <FormItem label="售卖设置" prop="is_free">
        <RadioGroup v-model="exercise.is_free">
          <Radio :label="0">
            <span>付费</span>
          </Radio>
          <Radio :label="1">
            <span>免费</span>
          </Radio>
        </RadioGroup>
        <div v-if="!exercise.is_free" style="margin-left:-60px;">
          <FormItem label="练习价格" prop="price" class="form-item-child" style="margin-bottom:24px;">
            <Input style="width:150px" type="text" v-model="exercise.price" placeholder="请输入价格" />
            <span class="tip">必须填写大于0的自然数</span>
          </FormItem>
        </div>
      </FormItem>
      <FormItem label="销售基数" prop="sales_base">
        <Input v-model="exercise.sales_base" placeholder="请输入时长" style="width: 50px;" type="number" />
        <span class="tip">销售基数使前端展示的销售量有虚拟增加</span>
      </FormItem>

      <AttrSelect class="attr-select" form-url="/api/module/attribute/4" :attr="exercise.attr" @onChange="onAttrChange"></AttrSelect>
      <FormItem style="text-align:center">
        <Button size="large" :to="{name: 'QuestionExercise'}">返回</Button>
        <Button
          size="large"
          style="margin: 0 15px;"
          type="primary"
          @click="submitForm('exercise')"
        >保存并返回</Button>
      </FormItem>
    </Form>
    <Modal
      class="grid-select"
      v-model="showSelectCourse"
      title="选择课程"
      @on-ok="confirmSelectCourse"
      @on-cancel="$refs.course.recoverSelectedItems(exam.courses)"
      width="800"
      scrollable
    >
      <CourseSelect ref="course" :selectedItems="courses" :selectType="courseSelecttype"></CourseSelect>
    </Modal>
  </div>
</template>

<script>
import UploadFile from "@/components/UploadFile.vue";
import CourseSelect from "@/components/GridSelect/CourseSelect";
import AttrSelect from '@/components/AttrSelect'
export default {
  name: "QuestionExerciseAdd",
  components: {
    UploadFile,
    CourseSelect,
    AttrSelect
  },
  data() {
    return {
      id: this.$route.query.id,
      exercise: {
        name: "",
        classify_id: "",
        indexpic: "",
        mainpic: "",
        course_id: 0,
        price: 0,
        sales_base: 0,
        is_free: 1,
        related_course_id: 0,
        related_course: {
          name: ''
        },
        attr: [],
        is_related_course: 0
      },
      ruleExercise: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        classify_ids: [{ required: true, message: "请选择分类"}],
        indexpic: [{ required: true, message: "请上传封面图"}],
        mainpic: [{ required: true, message: "请上传详情页封面图"}]
      },
      catagoris: [],
      showSelectCourse: false,
      courses: [],
      courseSelecttype: 'single'
    };
  },
  created() {
    this.retquestCatagory();
    if( this.id ) {
      this.retquestExercise()
    }
  },
  methods: {
    async retquestCatagory(){
      let catagoris = await this.$http.get("/api/course/classify");
      this.catagoris = catagoris;
    },
    retquestExercise(){
      this.$http.get(`/api/exam/exercise/${this.id}`).then((res) => {
        res.price = res.price/100;
        res.is_free = res.price > 0 ? 0 : 1;
        res.is_related_course = res.related_course_id > 0 ? 1 : 0;
        if( !res.related_course ) {
          res.related_course = { name: ''}
        }
        this.exercise = res

        let classifyList = [res.classify_id,0];
        for (let i = 0; i < this.catagoris.length; i++) {
          let classify = this.catagoris[i];
          if (classify.value == res.classify_id) {
            classifyList.push(classify.value);
            classifyList.push(0);
            break;
          }
          if (classify.children) {
            let c;
            for (c = 0; c < classify.children.length; c++) {
              let child = classify.children[c];
              if (child.value == res.classify_id) {
                classifyList.push(classify.value);
                classifyList.push(child.value);
                break;
              }
            }
            if (c < classify.children.length) {
              break;
            }
          }
        }
        this.exercise.classify_ids = classifyList;
      });
    },
    confirmSelectCourse() {
      this.showSelectCourse = false;
      let list = this.$refs.course.getSelectList();
      this.courses = list;
      this.exercise.related_course_id = list[0].id;
      this.exercise.related_course.id = list[0].id;
      this.exercise.related_course.name = list[0].title;
    },
    relatedCourseDelete() {
      this.courses = [];
      this.exercise.related_course_id = 0;
      this.exercise.related_course.id = 0;
      this.exercise.related_course.name = '';
    },
    onUploadSuccess(data) {
      this.exercise.indexpic = data.path;
    },
    onUploadMainSuccess(data) {
      this.exercise.mainpic = data.path;
    },
    onAttrChange(val) {
      this.exercise.exercise_attr = val
    },
    submitForm(name) {
      this.$refs[name].validate(valid => {
        if (!valid) {
          return;
        } else {
          let params = {};
          for (let i in this.exercise) {
            if (
              i == "is_free" &&
              this.exercise.is_free == 1
            ) {
              params.price = 0;
            } else if (i == "classify_ids") {
                params.classify_id = this.exercise.classify_ids[1] || this.exercise.classify_ids[0]
            } else {
              params[i] = this.exercise[i];
            }
          }
          params.price = params.price  * 100;
          if( this.id > 0 ){
            this.$http.put(`/api/exam/exercise/${this.id}`, params).then(() => {
              this.$router.push({
                name: "QuestionExercise"
              });
            });
          }else {
            this.$http.post(`/api/exam/exercise`, params).then(() => {
              this.$Message.createSuccess();
              this.$router.push({
                name: "QuestionExercise"
              });
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.choose-studens {
  padding-left: 60px;
  span {
    padding-left: 20px;
    color: #2d8cf0;
    cursor: pointer;
  }
}
.paper-exam {
  .attr-select{
    max-width: 400px;
  }
}
</style>
